import moment from 'moment';
import Cookies from 'universal-cookie';
import GetEvent from '../services/getEvent';
import GetCompany from '../services/getCompany';
import GetCompanies from '../services/getCompanies';
import GetInvestors from '../services/getInvestors';
import GetMeetings from '../services/getMeetings';
import GetBreaks from '../services/getBreaks';
import getInvestor from '../services/getInvestor';
import PdfCompany from './pdf/companyScheduleJSON';
import PdfAllCompany from './pdf/companyScheduleJSON_ALL';
import PdfAllInvestors from './pdf/investorScheduleJSON_ALL';
import PdfInvestor from './pdf/investorScheduleJSON';
import validator from 'validator'

export default class Utils {

  static validateEmail = (email) => {
    if (validator.isEmail(email)) {
      return true;
    } else {
        return false;
    }
  }

  static makeid = () => {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  
    for (var i = 0; i < 15; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
  
    return text;
  }

    static async getPdfUrl(scheduleType, scheduleSubject){

        const cookies = new Cookies();
        var token = cookies.get('token', { path: '/' });
        var uname = cookies.get('username', { path: '/' });
        const currentEventId = cookies.get('currentEventId', { path: '/' });

        this.event = await GetEvent(uname, token, currentEventId);

        this.companies = await GetCompanies(uname, token, currentEventId);
        this.investors = await GetInvestors(uname, token, currentEventId);
        this.company = await GetCompany(uname, token, currentEventId, scheduleSubject);
        this.investor = await getInvestor(uname, token, currentEventId, scheduleSubject);
        this.meetings = await GetMeetings(uname, token, currentEventId);
        this.breaks = await GetBreaks(uname, token, currentEventId);

        var pdfUrl = '';

        if (scheduleType == 'company'){
            pdfUrl = await PdfCompany.getAddress(this.event, this.company, this.breaks, this.meetings, '');
        } else if (scheduleType == 'investor'){
            pdfUrl = await PdfInvestor.getAddress(this.event, this.investor, this.breaks, this.meetings, '');
        } else if (scheduleType == 'allCompanies'){
            pdfUrl = await PdfAllCompany.getAddress(this.event, this.companies, this.breaks, this.meetings, this.updateWaitDialog.bind(this));
        } else if (scheduleType == 'allInvestors'){
            pdfUrl = await PdfAllInvestors.getAddress(this.event, this.investors, this.breaks, this.meetings, this.updateWaitDialog.bind(this));
        }

        return pdfUrl;
    }


    static async goToPdfPage(){

        const cookies = new Cookies();
        this.scheduleType = cookies.get('scheduleType');
        this.scheduleSubject = cookies.get('scheduleSubject');

        this.pdfUrl = await this.getPdfUrl(this.scheduleType, this.scheduleSubject);
        if (this.pdfUrl.indexOf('/undefined') == -1)
            window.open(this.pdfUrl, '_blank');
            // window.location.assign(this.pdfUrl);
        else {
            alert ('Cannot generate the pdf')
        }
    }


    static escapeString (str) {
        if (!str) return str
        return str.replace(/[\0\x08\x09\x1a\n\r"'\\\%]/g, function (char) {
            switch (char) {
                case "\0":
                    return "\\0";
                case "\x08":
                    return "\\b";
                case "\x09":
                    return "\\t";
                case "\x1a":
                    return "\\z";
                case "\n":
                    return "\\n";
                case "\r":
                    return "\\r";
                case "\"":
                case "'":
                case "\\":
                case "%":
                    return "\\"+char; // prepends a backslash to backslash, percent,
                                      // and double/single quotes
                default:
                    return char;
            }
        });
    }
    
    static getHoursArray(){
        var arr = [];
        for (var i = 0; i < 24; i++){
            arr.push(i);
        }
        return arr;
    }

    static getMinutesArray(){
        var arr = [];
        for (var i = 0; i < 60; i+=5){
            arr.push(i);
        }
        return arr;
    }


    static roundTime (str) {
        if (str.length == 1){
            return "0"+str;
        }
        else return str;
    }

    static checkInvestor(investors, id){
        for (var i = 0; i < investors.length; i++) {
          if (investors[i].id == id) 
            return true;
        }
        return false;
      }


      static checkBreakPossible(meetings, breaks, type, subjectId, date, hour, minutes, slots){

        if (Utils.checkBreak(breaks, date, hour, minutes, slots, type, subjectId) == false) {
            alert ('The company/investor has a break in this time interval'); 
            return false;
        }

        if (type == 'company'){
            if (Utils.checkCompanyAvailable(meetings, subjectId, date, hour, minutes, slots, null) == false) {
                alert ('The company has already a meeting in this time interval'); 
                return false;
            }
        }
        else {
            let checkInvestor = Utils.checkInvestorAvailable(meetings, [subjectId], date, hour, minutes, slots);
            if (checkInvestor != 'nothing') {
                alert ('The investor has already a meeting in this time interval'); 
                return false;
            }
        }
        return true;
    }

      static checkMeetingPossible(meetings, breaks, type, companyId, investors, date, hour, minutes, slots, currentMeetingId){

        if (Utils.checkBreak(breaks, date, hour, minutes, slots, 'company', companyId) == false) {
            alert ('The company has a break in this time interval'); 
            return false;
        }

        for (var i = 0; i < investors.length; i++){
            var investor = investors[i];
            if (Utils.checkBreak(breaks, date, hour, minutes, slots, 'investor', investor) == false) {
                alert ('An investor has a break in this time interval'); 
                return false;
            }
        };

        if (Utils.checkCompanyAvailable(meetings, companyId, date, hour, minutes, slots, currentMeetingId) == false) {
            alert ('The company has already a meeting in this time interval'); 
            return false;
        }
        let checkInvestor = Utils.checkInvestorAvailable(meetings, investors, date, hour, minutes, slots);
        if (checkInvestor != 'nothing') {
            alert ('The investor ' + checkInvestor + ' has already a meeting in this time interval'); 
            return false;
        }
        return true;
    }



      static checkBreak(breaks, date, hour, minutes, slots, type, subject){

        for (var i = 0; i < breaks.length; i++){
            let b = breaks[i];
            if (b.date != date) continue;
            if (b.type != type) continue;
            if (b.subject != subject) continue;

            var breakStart = moment(b.date + " " + b.hour+":"+b.minutes, "DD/MM/yyyy HH:mm");
            var breakEnd = moment(breakStart).add(parseInt(b.slots) * 5, 'minutes');

            var currentClickTime = moment(date + " " + hour+":"+minutes, "DD/MM/yyyy HH:mm");
            if (currentClickTime >= breakStart && breakEnd > currentClickTime) 
                return false;
            currentClickTime = moment(currentClickTime).add(parseInt(slots) * 5, 'minutes');
            if (currentClickTime > breakStart && breakEnd >= currentClickTime) 
                return false;
        }

        return true;
      }


      static checkCompanyAvailable(meetings, companyId, date, hour, minutes, slots, currentMeetingId){

        for (var i = 0; i < meetings.length; i++){
            let m = meetings[i];
            if (currentMeetingId != null && m.id == currentMeetingId) continue;
            if (m.company_id != companyId) continue;
            if (m.date != date) continue;

            var meetingStart = moment(m.date + " " + m.hour+":"+m.minutes, "DD/MM/yyyy HH:mm");
            var meetingEnd = moment(meetingStart).add(parseInt(m.slots) * 5, 'minutes');

            var currentClickTime = moment(date + " " + hour+":"+minutes, "DD/MM/yyyy HH:mm");
            if (currentClickTime >= meetingStart && meetingEnd > currentClickTime) 
                return false;

            var currentEndTime = moment(currentClickTime).add(parseInt(slots) * 5, 'minutes');
            if (currentEndTime > meetingStart && meetingEnd >= currentEndTime) 
                return false;

            if (currentClickTime < meetingStart && meetingEnd < currentEndTime) 
                return false;
        }

        return true;
    }

    static checkInvestorAvailable(meetings, investors, date, hour, minutes, slots){

        for (var i = 0; i < meetings.length; i++){
            let m = meetings[i];

            let checkInvestor = Utils.checkDoubleInvestor(investors, m.investors);
            if (checkInvestor.res == false) continue;
            if (m.date != date) continue;

            var meetingStart = moment(m.date + " " + m.hour+":"+m.minutes, "DD/MM/yyyy HH:mm");
            var meetingEnd = moment(meetingStart).add(parseInt(m.slots) * 5, 'minutes');

            var currentClickTime = moment(date + " " + hour+":"+minutes, "DD/MM/yyyy HH:mm");
            if (currentClickTime >= meetingStart && meetingEnd > currentClickTime) 
                return checkInvestor.desc;
 
            var currentEndTime = moment(currentClickTime).add(parseInt(slots) * 5, 'minutes');
            if (currentEndTime > meetingStart && meetingEnd >= currentEndTime) 
                return false;

            if (currentClickTime < meetingStart && meetingEnd < currentEndTime) 
                return false;
        }

        return 'nothing';
    }


    static checkDoubleInvestor(investors, investors2){

        for (var i = 0; i < investors.length; i++){
            let inv1 = investors[i];
            for (var j = 0; j < investors2.length; j++){
                let inv2 = investors2[j].id;
                if (parseInt(inv1) == parseInt(inv2)){
                    return ({
                        res: true,
                        desc: investors2[j].name
                    });
                }
            }
        }
        return ({res: false});
    }
}

